export default [
    {
        path: 'interfaces', component: () => import('@/views/interfaces/Home.vue'),
        children: [
            {
                path: "",
                name: "search",
                component: () => import("@/views/interfaces/components/Search.vue"),
            },
            {
                path: "/interfaces/:interfaceId",
                name: "edit",
                component: () => import("@/views/interfaces/components/Manager.vue"),
                props:true
            },

        ]
    }
]